import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {

    // This method is used to initialize the class instance using translate and route
    constructor(
        private translate: TranslateService,
        private route: ActivatedRoute
    ) { }

    // This method is used to init language
    initLanguage(): void {
        let lang = localStorage.getItem('selectedLang') || 'en';
        this.route.queryParams.subscribe(params => {
            if (params['lang']) {
                lang = params['lang'];
            }
        });
        localStorage.setItem('selectedLang', lang);
        this.applyLanguage(lang);
    }

    // This method is used to apply language using lang
    private applyLanguage(lang: string) {
        this.translate.use(lang);
        document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';

        // // Always set default
        // this.translate.setDefaultLang(lang);

        // // Then use it
        // this.translate.use(lang);

        // // Update dir
        // document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
        // document.documentElement.lang = lang;
    }

    // This method is used to get current lang
    getCurrentLang(): string {
        let lang: any = localStorage.getItem('selectedLang'); //this.translate.currentLang;
        return lang;
    }

    // This method is used to set language
    setLanguage(lang: string): void {
        const normalized = (lang || 'en').toLowerCase();
        localStorage.setItem('selectedLang', normalized);
        this.applyLanguage(normalized);
    }

    // This method is used to toggle language
    toggleLanguage(): void {
        const current = this.getCurrentLang() || 'en';
        const next = current === 'ar' ? 'en' : 'ar';
        this.setLanguage(next);
    }
}
